
import { Button } from "@/components/ui/button";
import dnaDarkBg from "@/assets/dna-dark-bg.jpg";

const Hero = () => {
  // 버튼 링크
  const JAX_MODEL_SEARCH = "https://mice.jax.org"; // Advanced Mice Search
  const CONTACT_PATH = "/contact?type=consultation"; // 내부 문의/상담 페이지 - 일반상담으로 직접 연결

  return (
    <section
      aria-labelledby="hero-title"
      className="relative min-h-[70vh] bg-gradient-to-b from-primary to-primary/90 overflow-hidden flex items-center"
    >
      {/* DNA helix background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{ backgroundImage: `url(${dnaDarkBg})` }}
      />

      {/* Floating shapes */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white/10 rounded-full blur-sm" />
        <div className="absolute top-40 right-20 w-48 h-48 bg-white/7 rounded-full blur-md" />
        <div className="absolute bottom-20 left-1/4 w-24 h-24 bg-white/12 rounded-full blur-sm" />
        <div className="absolute bottom-40 right-10 w-40 h-40 bg-white/8 rounded-full blur-lg" />
      </div>

      <div className="container relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 pt-20 sm:pt-24 md:pt-28 lg:pt-32 xl:pt-36 pb-16 sm:pb-20 md:pb-24 lg:pb-28 xl:pb-32">
        <div className="grid lg:grid-cols-[3fr,1fr] gap-8 sm:gap-12 lg:gap-16 xl:gap-20 items-center">
          {/* Left content */}
          <div className="max-w-5xl">
            {/* Headline */}
            <h1
              id="hero-title"
              className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-5xl font-bold text-white mb-3 sm:mb-4 leading-tight tracking-tight"
            >
              Central TG - JAX<sup>®</sup> 한국 공식 대리점

            </h1>

            {/* Tagline */}
            <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold text-white/95 mb-6 sm:mb-8 leading-tight tracking-tight">
              빠른 상담, 편리한 주문, 합리적인 가격
            </p>

            {/* Sub copy */}
            <div className="border-l-4 border-white/30 pl-4 sm:pl-6 mb-8 sm:mb-10 lg:mb-12">
              <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 leading-relaxed mb-3 sm:mb-4">
                센트럴티지
                <span style={{ fontSize: "70%" }} className="align-baseline">(주)</span>
                는 The Jackson Laboratory(JAX<sup>®</sup>)의 공식 대리점으로서,<br className="hidden sm:block" />
                위와 같은 목표로 연구자들에게 유전자변형 모델을 공급하고 있습니다.
              </p>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg text-white/80 leading-relaxed">
                Central TG Inc. is the authorized distributor of The Jackson Laboratory (JAX<sup>®</sup>) in South Korea, providing researchers with genetically engineered animal models.
              </p>
            </div>

            {/* CTA buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 lg:gap-6">
              <Button
                asChild
                size="lg"
                className="bg-jax-yellow text-jax-dark-blue hover:bg-jax-yellow/90 text-base sm:text-lg px-6 sm:px-7 py-4 sm:py-6 font-semibold"
              >
                <a href={JAX_MODEL_SEARCH} target="_blank" rel="noopener noreferrer">
                  JAX 모델 검색
                </a>
              </Button>

              <Button
                asChild
                size="lg"
                className="bg-white text-[#0B2A4A] hover:bg-white/90 text-base sm:text-lg px-6 sm:px-7 py-4 sm:py-6 font-semibold"
              >
                <a href={CONTACT_PATH}>문의하기</a>
              </Button>
            </div>
          </div>

          {/* Right logo */}
          <div className="flex justify-center lg:justify-end mt-8 lg:mt-0">
            <img
              src="/lovable-uploads/3c305efd-769f-445b-bb40-2296747e2799.png"
              alt="The Jackson Laboratory(JAX®) 한국 공식 대리점 센트럴티지(Central TG) 로고"
              className="max-w-[200px] sm:max-w-[240px] md:max-w-[280px] lg:max-w-[300px] xl:max-w-[320px] w-full h-auto opacity-90"
              loading="eager"
              decoding="sync"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
